import { provideLocal, injectLocal } from '@vueuse/core';
import useAvailability from '@modules/upc/composables/useAvailability';
import { useProduct } from '@modules/product';
import { useFeatureEligibility } from '@modules/featureControl';
import { useColor } from '@modules/color';
import { useSize } from '@modules/size';
import { useType as useOrientation } from '@modules/types';
import { validateUPC } from '../utils';
import { UPC_VALIDATOR_REPOSITORY } from '../constants';

export const useUpcValidatorProvide = () => {
  const { productId } = useProduct();
  const { colors, selectedColor } = useColor(productId);
  const { sizes, selectedSize, label: sizeName } = useSize(productId);
  const { isSizeAvailable, isColorAvailable } = useAvailability(productId);
  const { types: orientationArray, selectedType: selectedOrientation, label: typeName } = useOrientation(productId);
  const { isMattress3v } = useFeatureEligibility();

  const upcValidator = () => validateUPC({
    selectedColor: selectedColor.value,
    selectedSize: selectedSize.value,
    selectedOrientation: selectedOrientation.value,
    colors: colors.value,
    sizes: sizes.value,
    orientations: orientationArray.value,
    isColorAvailable,
    isSizeAvailable,
    typeName: typeName?.value,
    sizeName: sizeName?.value,
    excludeColorLabel: isMattress3v,
  });

  provideLocal(UPC_VALIDATOR_REPOSITORY, upcValidator);
};

export const useUpcValidator = () => {
  /**
   * @type {PayloadValidator<void>}
   */
  const upcValidator = injectLocal(UPC_VALIDATOR_REPOSITORY);
  if (typeof upcValidator === 'undefined') {
    throw new TypeError('useUpcValidator() is called without provider.');
  }

  return { upcValidator };
};
